import HeaderContextProvider, {
  HeaderContext,
} from './HeaderContext';

export default HeaderContext;
export { HeaderContextProvider };
